import LineOrange from "../../../common/LineOrange/LineOrange";
import style from "../style.module.css";

export const BoursTable = () => {
  return (
    <>
      <div className={style.sectionContent}>
        <div className="container text-right">
          <div className="title text-center d-flex flex-column">
            <h3 className=" mt-5">
              شرایط اختصاصی پذیرش در بازارهای اول و دوم بورس
            </h3>
          </div>
          <div className="table-responsive mb-5">
            <table className={`${style.tableParent + " table mb-5"}`}>
              <tr>
                <th>شرح</th>
                <th>تابلوی اصلی بازار</th>
                <th>تالبوی فرعی بازار</th>
                <th>تابلو دوم</th>
              </tr>
              <tr>
                <td>حداقل سرمایه ثبت شده یا حداقل ارزش بازار سهام شرکت </td>
                <td>
                  ٢,٠٠٠
                  <br />
                  ١٢,٠٠٠
                </td>
                <td>
                  ۱،۵۰۰
                  <br />
                  8,000
                </td>
                <td>
                  ۶٠٠
                  <br />
                  ۵,۰۰۰
                </td>
              </tr>
              <tr>
                <td>حداقل سهام شناور</td>
                <td>۲۵ %</td>
                <td>% ٢٠</td>
                <td>۱۵ %</td>
              </tr>
              <tr>
                <td>
                  حداقل درصد سهام شناور آزاد با ارزش بازار سهام شناور آزاد{" "}
                </td>
                <td>6،۰۰۰ - ۱5%</td>
                <td>۴،۰۰۰ - ۱۲%</td>
                <td>۲،۵۰۰ - ۷%</td>
              </tr>
              <tr>
                <td>حداقل تعداد سهامداران </td>
                <td>۱,۰۰۰</td>
                <td>۷۵۰</td>
                <td>۲۵۰</td>
              </tr>
              <tr>
                <td>حداقل سابقه فعالیت در صنعت </td>
                <td>3</td>
                <td>3</td>
                <td>2</td>
              </tr>
              <tr>
                <td>دوره سوددهی قبل از پذیرش </td>
                <td>3</td>
                <td>2</td>
                <td>1</td>
              </tr>
              <tr>
                <td>حداقل سرمایه ثبت شده یا حداقل ارزش بازار سهام شرکت </td>
                <td>٣٠ %</td>
                <td>٢٠ %</td>
                <td>%۱۵</td>
              </tr>
              <tr>
                <td>
                  مثبت بودن مجموع جریان خالص وجه نقد ناشی از فعالیتهای عملیاتی
                  دو دوره مالی منتهی به پذیرش{" "}
                </td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
              </tr>
              <tr>
                <td colSpan={4} className="text-center">
                  مجموع حقوق صاحبان سهام در زمان پذیرش باید حداقل 900 میلیارد
                  ریال باشد
                </td>
                {/* <td>
                  ٢,٠٠٠
                  <br />
                  ١٢,٠٠٠
                </td>
                <td>
                  ۱،۵۰۰
                  <br />
                  8,000
                </td>
                <td>
                  ۶٠٠
                  <br />
                  ۵,۰۰۰
                </td> */}
              </tr>
            </table>

            <div className="title text-center d-flex flex-column">
              <h3 className=" mt-5">
                شرایط اختصاصی پذیرش در تابلوهای مختلف فرابورس
              </h3>
            </div>
            <table className={`${style.tableParent + " table"}`}>
              <tr>
                <th>شرح شرایط پذیرش شرکت ها در فرابورس </th>
                <th>بازار اول</th>
                <th>بازار دوم</th>
                <th>شرکت های کوچک و متوسط</th>
              </tr>
              <tr>
                <td>شرکت باید سهامی عام باشد. </td>
                <td>بلی</td>
                <td>بلی</td>
                <td>بلی</td>
              </tr>
              <tr>
                <td>حداقل سرمایه ثبت شده برای شرکت متقاضی (میلیارد ریال)</td>
                <td>
                  ۵۰۰ <br />
                  (ارزش بازار سهام شرکت حداقل ۲۰۰۰ میلیارد ریال)
                </td>
                <td>
                  ۱۵۰ <br />
                  (ارزش بازار سهام شرکت حداقل ۸۰۰ میلیارد ریال)
                </td>
                <td>
                  جمع حقوق صاحبان سهام
                  <br /> حداقل ۱ میلیارد ریال و حداکثر۵۰۰ میلیارد ریال
                </td>
              </tr>
              <tr>
                <td>تقسیم تمامی سهام به سهام عادی و نداشتن امتیاز خاص </td>
                <td>بلی</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>درصد شناور بودن سهام (درصد) </td>
                <td>10</td>
                <td>5</td>
                <td>-</td>
              </tr>
              <tr>
                <td>حداقل تعداد سهامداران (نفر) </td>
                <td>200</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>حداقل سابقه فعالیت در صنعت مربوطه (سال)</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>حداقل دوره سودآور بودن شرکت قبل از پذیرش (سال)</td>
                <td>1</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>نداشتن زبان انباشته</td>
                <td>بلی</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>
                  حداقل نسبت حقوق صاحبان سهام به کل دارایی های شرکت (درصد){" "}
                </td>
                <td>15</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>تنظیم اساسنامه منطبق با اساسنامه نمونه مصوب سازمان </td>
                <td>بلی</td>
                <td>بلی</td>
                <td>بلی</td>
              </tr>
              <tr>
                <td>بالا بودن کیفیت سود عملیاتی شرکت</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>مثبت بودن جریان خالص وجه نقد شرکت</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>استفاده از سیستم حسابداری مطلوب با تائید حسابرس </td>
                <td>بلی</td>
                <td>بلی</td>
                <td>بلی</td>
              </tr>
              <tr>
                <td>
                  نداشتن سابقه محکومیت قطعی و یا کیفری اعضای هیئت مدیره و مدیر
                  عامل{" "}
                </td>
                <td>بلی</td>
                <td>بلی</td>
                <td>بلی</td>
              </tr>
              <tr>
                <td>داشتن بازار گردان به تشخیص هیئت پذیرش </td>
                <td>بلی</td>
                <td>بلی</td>
                <td>-</td>
              </tr>
            </table>

            <div className="title text-center d-flex flex-column">
              <h3 className=" mt-5">
                شرایط پذیرش در بازارهای ابزارهای نوین مالی{" "}
              </h3>
            </div>
            <table className={`${style.tableParent + " table"}`}>
              <tr>
                <th colSpan={2}>شرح</th>
                <th>با نام</th>
                <th>
                  حداقل سرمایه <br /> حداقل مبلغ اوراق
                </th>
                <th>سررسید</th>
                <th>توضیحات</th>
              </tr>
              <tr>
                <td rowSpan={2}>اوراق مشارکت</td>
                <td>اوراق مشارکت با اخذ مجوز از سازمان</td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>۱۰۰ میلیارد ریال </td>
                <td>بیش از ا سال</td>
                <td>حداقل یک بازارگردان حداقل یک بازارگردان</td>
              </tr>
              <tr>
                <td>اوراق مشارکت دولتی / شهرداری ها</td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>-</td>
                <td>حداقل 6 ماه</td>
                <td>حداقل یک بازارگردان</td>
              </tr>
              <tr>
                <td rowSpan={2}>گواهی سرمایه گذاری</td>
                <td>معاملات دست دوم انحصاری فرابورس بعد از پذیرش</td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>50 میلیارد ریال </td>
                <td>-</td>
                <td>ثبت شده</td>
              </tr>
              <tr>
                <td>زمین و ساختمان </td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>۱۰۰ میلیارد ریال</td>
                <td>-</td>
                <td>ثبت شده</td>
              </tr>
              <tr>
                <td colSpan={2}>گواهی های سپرده سرمایه گذاری</td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>۱۰۰ میلیارد ریال </td>
                <td>6 ماه</td>
                <td>
                   - پرداخت اصل و سود گواهینامه ها توسط بانک تعهد و تامین
                  شوند
                  <br /> -معاملات دست دوم انحصاری فرابورس بعد از پذیرش
                  <br /> -گواهینامه ها توسط بانک عامل صادر شود
                </td>
              </tr>
              <tr>
                <td colSpan={2}>صکوک</td>
                <td>
                  <img src={"/asset/images/Path 80.png"} className="" alt="" />
                </td>
                <td>-</td>
                <td>-</td>
                <td>حداقل یک بازار گردان </td>
              </tr>
              <tr>
                <td colSpan={2}>سایر ابزارهای مالی</td>
                <td colSpan={4}>
                - تغییر شرایط توسط هیئت پذیرش 
                <br />- به تشخیص شورا قابل معامله 
                <br /> - انتشار با مجوز سازمان 

                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
